import { render, staticRenderFns } from "./password-change-page.html?vue&type=template&id=7ac4b303&"
import script from "./password-change-page.ts?vue&type=script&lang=ts&"
export * from "./password-change-page.ts?vue&type=script&lang=ts&"
import style0 from "./password-change-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports